<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="location-icon"
    :width="size - 2"
    :height="size"
    viewBox="0 0 14 17"
    fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.42042 15.9148C9.18278 15.3077 9.9449 14.6218 10.6582 13.8689C12.7383 11.6732 14 9.36012 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 9.36012 1.26168 11.6732 3.34183 13.8689C4.0551 14.6218 4.81722 15.3077 5.57958 15.9148C5.84682 16.1276 6.09548 16.3157 6.31945 16.4774C6.45594 16.576 6.5554 16.6449 6.61171 16.6824C6.84684 16.8392 7.15316 16.8392 7.38829 16.6824C7.4446 16.6449 7.54406 16.576 7.68055 16.4774C7.90452 16.3157 8.15318 16.1276 8.42042 15.9148ZM9.64027 12.9037C8.97541 13.6055 8.26097 14.2485 7.54676 14.8172C7.35182 14.9724 7.16806 15.1131 6.99844 15.2384C6.82882 15.1131 6.64506 14.9724 6.45011 14.8172C5.7359 14.2485 5.02146 13.6055 4.3566 12.9037C2.49926 10.9431 1.39844 8.92496 1.39844 6.99758C1.39844 3.90479 3.90564 1.39758 6.99844 1.39758C10.0912 1.39758 12.5984 3.90479 12.5984 6.99758C12.5984 8.92496 11.4976 10.9431 9.64027 12.9037ZM6.99531 9.79873C5.44892 9.79873 4.19531 8.54513 4.19531 6.99873C4.19531 5.45233 5.44892 4.19873 6.99531 4.19873C8.54171 4.19873 9.79531 5.45233 9.79531 6.99873C9.79531 8.54513 8.54171 9.79873 6.99531 9.79873ZM8.40156 7.00242C8.40156 7.77562 7.77476 8.40242 7.00156 8.40242C6.22836 8.40242 5.60156 7.77562 5.60156 7.00242C5.60156 6.22922 6.22836 5.60242 7.00156 5.60242C7.77476 5.60242 8.40156 6.22922 8.40156 7.00242Z"
      :fill="color" />
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: Number,
      default: 15,
    },
    color: {
      type: String,
      default: 'var(--bs-primary)',
    },
  });
</script>

<style lang="css" scoped>
  path.location-icon__path {
    fill: var(--bs-primary);
  }
</style>
